import { CustomFieldElementType, ExtraField, ExtraFieldType } from '@web/graphql-components'

const valueKey = (field: ExtraField) =>
  field.type === ExtraFieldType.DedicateTo
    ? 'should-dedicate'
    : field.customField?.id && field.type !== ExtraFieldType.Comments
      ? field.customField.id
      : field.name

const fieldValue = (field: ExtraField, values: Record<string, string>) =>
  (values[valueKey(field)] ?? values[field.name] ?? '').trim()

const isChecked = (field: ExtraField, values: Record<string, string>) => {
  const raw = fieldValue(field, values)
  if (!raw) {
    return field.defaultValue === 'true'
  }

  return raw === 'true'
}

const showsConditionalFields = (field: ExtraField) =>
  field.type === ExtraFieldType.DedicateTo ||
  field.customField?.elementType === CustomFieldElementType.Checkbox ||
  field.customField?.elementType === CustomFieldElementType.Switch

const isMissingRequiredValue = (field: ExtraField, values: Record<string, string>) => {
  if (!field.isRequired) {
    return false
  }

  const elementType = field.customField?.elementType
  if (
    elementType === CustomFieldElementType.Checkbox ||
    elementType === CustomFieldElementType.Switch ||
    field.type === ExtraFieldType.DedicateTo
  ) {
    return !isChecked(field, values)
  }

  return !fieldValue(field, values)
}

export const getMissingRequiredPostDonationFields = (fields: ExtraField[], values: Record<string, string>) => {
  const missing: ExtraField[] = []

  const visit = (field: ExtraField) => {
    if (field.isHidden || field.type === ExtraFieldType.Profile) {
      return
    }

    if (isMissingRequiredValue(field, values)) {
      missing.push(field)
    }

    if (!showsConditionalFields(field) || !isChecked(field, values)) {
      return
    }

    field.conditionalFields?.forEach(visit)
  }

  fields.forEach(visit)
  return missing
}

export const requiredFieldsMessage = (fields: ExtraField[]) => {
  const labels = fields.map((field) => field.label).filter(Boolean)
  if (labels.length === 0) {
    return 'Please complete the required fields.'
  }

  if (labels.length === 1) {
    return `Please complete ${labels[0]}.`
  }

  return `Please complete ${labels.slice(0, -1).join(', ')} and ${labels.at(-1)}.`
}
